import React from 'react';
import PropTypes from 'prop-types';

const Missing = (
    {
        width = 26,
        height = 26,
    }) =>

        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 16" fill="none">
            <circle cx="8" cy="8" r="7.5" stroke="#3F53CA" strokeWidth="1" fill="none"/>
            <path d="M10.03 5.27L8.00002 7.29L5.97002 5.27L5.27002 5.97L7.29002 8L5.27002 10.03L5.97002 10.73L8.00002 8.71L10.03 10.73L10.73 10.03L8.71002 8L10.73 5.97L10.03 5.27Z" fill="#E10000"/>
            <path d="M9.5 2.71L9.25 3.7C11.12 4.25 12.5 5.96 12.5 8C12.5 10.48 10.48 12.5 8 12.5C5.52 12.5 3.5 10.48 3.5 8C3.5 5.52 5.52 3.5 8 3.5C8.04 3.5 8.08 3.51 8.12 3.51L8.37 2.52C8.25 2.52 8.12 2.5 8 2.5C4.97 2.5 2.5 4.97 2.5 8C2.5 11.03 4.97 13.5 8 13.5C11.03 13.5 13.5 11.03 13.5 8C13.5 5.49 11.8 3.37 9.5 2.71Z" fill="#E10000"/>
        </svg>


Missing.propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
}

export default Missing



// WEBPACK FOOTER //
// ./src/components/Icon/svg/missing.js